import './site_common'
import { Application } from 'stimulus'
import 'PackWerkNurikaeSite/pages/campaigns/cashback/index/component'

const application = Application.start()
